var CITY_DISTRICT_NUMBER_PATTERN = /\s+\d+$/;
/**
 * A title's publication place is the residential municipality ("Obec" of the RÚIAN / ARES standardized
 * address), never the city district: "Praha 2" -> "Praha", "Plzeň 3" -> "Plzeň". A municipality without
 * a trailing district number stays as it is. Same rule as the publishers module applies to addresses.
 */
export var normalizeMunicipality = function (municipality) {
    if (!municipality || !municipality.trim())
        return municipality;
    return municipality.trim().replace(CITY_DISTRICT_NUMBER_PATTERN, "");
};
